import { useState } from 'react';
import { connectDscvryIntegration } from '../api/contactBuilder';
import { useAuthState } from '../contexts/authcontext';
import { getDscvrySignupUrlFromEnv, getDscvryWebhookUrlFromEnv } from '../utils/contactBuilder';

type DscvryWebhookConnectProps = {
  resourceId?: string
  resourceCommunityId?: string
  signupUrl?: string
  webhookUrl?: string
};

/** Saves the DSCVRY integration and shows the webhook signing secret once. */
const DscvryWebhookConnect = ({ resourceId, resourceCommunityId, signupUrl, webhookUrl }: DscvryWebhookConnectProps) => {
  const { communityId } = useAuthState();
  const [busy, setBusy] = useState(false);
  const [secret, setSecret] = useState('');
  const [error, setError] = useState('');
  const cid = communityId || resourceCommunityId || '';

  const connect = async () => {
    if (!cid || !resourceId) {
      setError('Open this resource from a community account.');
      return;
    }
    setBusy(true);
    setError('');
    setSecret('');
    try {
      const integration = await connectDscvryIntegration(
        cid,
        resourceId,
        (signupUrl || '').trim() || getDscvrySignupUrlFromEnv(),
        (webhookUrl || '').trim() || getDscvryWebhookUrlFromEnv(),
      );
      setSecret(integration?.secret || '');
    } catch (err) {
      setError('The partner connection could not be saved.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="sm:col-span-2 space-y-2" data-testid="dscvry-webhook-connect">
      <button type="button" className="rounded-lg border border-[#E4EEF1] px-3 py-2 font-raleway text-sm disabled:opacity-50" onClick={connect} disabled={busy}>
        {busy ? 'Connecting' : 'Connect webhook'}
      </button>
      {secret && (
        <p className="break-all rounded-lg bg-[#F8F8F8] p-3 font-open-sans text-sm" data-testid="one-time-secret">
          Copy this signing secret now. It will not be shown again: {secret}
        </p>
      )}
      {error && <p className="font-open-sans text-sm text-[#B91C1C]">{error}</p>}
    </div>
  );
};

export default DscvryWebhookConnect;
